import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SPINNER_TEMPLATE } from 'src/app/constants';
import { DomSanitizer } from "@angular/platform-browser";
import { AuthService } from "src/app/services/auth.service";
import { ClientPortalUsersService } from "src/app/services/client-portal-users.service";
import { ClientPortalUser, IClientPortalUser } from "src/app/models/Client";
import { UsersService } from "src/app/services/users.service";
import { User } from "oidc-client";
import { ServerResponse } from "src/app/models/ServerResponse";
import { SnackBarService } from "src/app/services/snackbar.service";
import { SnackBarType } from "src/app/models/Snackbar";
import { NavigationEnd, Router } from "@angular/router";
import { filter, Subscription, take } from "rxjs";
import { UserProfile } from "src/app/models/UserProfile";
import { AlertsService } from "src/app/services/alerts.service";
import { ISAPI, ISFilterAPI, FilterOptionsType, FilterOperator, ISPagination, SortDirection } from "is-lib";
import { ThemeService } from "src/app/services/theme.service";
import { environment } from "src/environments/environment";
import { EntitiesService } from "src/app/services/entities.service";


export class Language {
  constructor(
    public code: string,
    public name: string,
    public flag: string,
    public flagSquare: string
  ) { }
}

@Component({
  selector: 'app-authenticated-layout',
  templateUrl: './authenticated-layout.component.html',
  styleUrls: ['./authenticated-layout.component.scss']
})
export class AuthenticatedLayoutComponent implements OnInit, OnDestroy {

  // Router events and the auth flag outlive the layout (it's recreated after signing in again)
  private _subscriptions: Subscription[] = [];

  constructor(
    private _userService: UsersService,
    private _alertsService: AlertsService,
    private _authService: AuthService,
    private _themeService: ThemeService,
    private _router: Router,
    private _entityService: EntitiesService,
    private _snackbarService: SnackBarService
  ) {
    this._subscriptions.push(_router.events.pipe(filter((route) => route instanceof NavigationEnd)).subscribe((route: any) => {
        if (route.url.includes('market-dealers')) {
          this._themeService.setTheme('mv-market-dealers');
        } else {
          this._themeService.setTheme('mv');
        }
        if (environment.blurPrices) {
          this._themeService.setPriceBlur(true);
        }
    }));
  }

  ngOnInit(): void {
    this._subscriptions.push(this._authService.authFlag$.subscribe( (oidcUser: User | null) => {
      if (oidcUser) {
        let loggedClient = localStorage.getItem('ClientPortalUser');
        
        if (loggedClient) {
          let clientData = JSON.parse(loggedClient);
          this._userService.userData = clientData;

          this._entityService.getUserEntityData(this._authService.email).subscribe({
            next: (result: any) => {
              if (result) {
                let clientData = new ClientPortalUser({
                  email: result.claims.email,
                  firstName: result.claims.firstName,
                  lastName: result.claims.lastName,
                  identityServerId: result.claims.id,
                  clientPortalId: result.user.id,
                  countryCode: result.country.twoLetterIsoCode,
                  avatar: result.user.avatar,
                  countryId: result.country.id,
                  tin: result.user.tin,
                  birthdate: result.user.birthDate,
                  contactNumber: result.user.contactNumber,
                  entityGuid: result.entity?.id,
                  entityExists: result.entity?.exists
                });

                this._userService.userData = clientData;
              } else {
                this._authService.signout();
              }
            },
            error: (err) => {
              this._authService.signout();
            }
          })
        }
      }
    } ));

    let bodyFilters = new ISAPI(
      [
        new ISFilterAPI('CreationDate', null, FilterOptionsType.date, undefined, SortDirection.desc, undefined, undefined, 'Created')
      ], 
      new ISPagination(10, 1)
    );

    if (this._userService.userData) {
      this._alertsService.getAlerts(this._userService.userCountryCode!, bodyFilters, false).subscribe( () => {
        this._alertsService.listenToNewAlerts();
      });
    } else {
      this._userService.userData$.pipe(take(1)).subscribe((user: ClientPortalUser | null) => {
        this._alertsService.getAlerts(user!.countryCode!, bodyFilters, false).subscribe( () => {
          this._alertsService.listenToNewAlerts();
        });
      })
    }
  }

  // @HostListener('window:beforeunload')
  // stopListeningToAlerts() {
  //   this._alertsService.stopListeningToAlerts();
  // }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // this.stopListeningToAlerts();
    this._subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }
  
}
